// @ts-nocheck

/**
 * * `inappropriate_content` - Inappropriate Content
 * `copyright` - Copyright Violation
 * `privacy` - Privacy Concern
 * `spam` - Spam
 * `other` - Other
 */
export type ReasonEnum = typeof ReasonEnum[keyof typeof ReasonEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReasonEnum = {
  inappropriate_content: "inappropriate_content",
  copyright: "copyright",
  privacy: "privacy",
  spam: "spam",
  other: "other",
} as const;
